/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'link': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9.761 13.796a4.843 4.843 0 006.843-.291l2.191-2.386a4.843 4.843 0 10-7.134-6.552l-.678.738a.75.75 0 101.105 1.015l.678-.738a3.343 3.343 0 014.925 4.522L15.5 12.49a3.343 3.343 0 01-5.323-.528.75.75 0 00-1.283.778c.233.383.522.74.867 1.056zm3.549-4.302a4.843 4.843 0 00-6.843.291l-2.191 2.386a4.843 4.843 0 007.135 6.552l.677-.738a.75.75 0 10-1.105-1.014l-.677.737a3.343 3.343 0 11-4.925-4.522L7.57 10.8a3.343 3.343 0 015.323.528.75.75 0 101.283-.778 4.847 4.847 0 00-.867-1.056z" _fill="#000"/>'
  }
})
